import { scrollTo } from "./Header";
import { FOOTER_FEATURE_HREFS } from "../../lib/featurePages";

const productCols = [
  { title: "Grow online discovery", items: ["Homepage & Webshop", "SEO Suite", "Smart Online Menu", "CMS Content Pages"] },
  { title: "Grow repeat orders", items: ["Branded Mobile Apps", "Marketing Campaigns", "Email & SMS Marketing", "Push Notifications", "Loyalty & Rewards"] },
  { title: "Grow online sales", items: ["Online Ordering", "Combos & Upsells", "Delivery Zones", "QR Dine-In & Reservations"] },
  { title: "Run your restaurant", items: ["Owner Admin App", "Live Order Hub", "Kitchen Printing", "Sales Analytics", "Multi-Store Control"] },
];

const resources = ["Case Studies", "Restaurant Marketing Guide", "SEO for Restaurants", "Restaurant Email Marketing", "Restaurant Mobile App", "Online Ordering Systems"];

const company = [
  { label: "About", href: "#manifesto" },
  { label: "How it works", href: "/how-it-works" },
  { label: "Pricing", href: "/pricing" },
  { label: "Careers", href: "#" },
  { label: "Partner with us", href: "#contact" },
];

const support = [
  { label: "hello@simplyowner.com", href: "mailto:hello@simplyowner.com" },
  { label: "Book a free demo", href: "#contact" },
  { label: "Owner Panel", href: "/admin" },
];

const legal = ["Privacy", "Website Terms", "Impressum", "Cookie Settings", "Accessibility"];

const legalRoutes = { Privacy: "/privacy", "Website Terms": "/terms", Impressum: "/impressum" };

const LinkBtn = ({ label, href, testid }) => (
  <button
    data-testid={testid}
    onClick={() => href && href !== "#" && (href.startsWith("#") ? scrollTo(href) : (window.location.href = href))}
    className="text-left text-[15px] text-black/60 hover:text-brand transition-colors duration-200 font-light"
  >
    {label}
  </button>
);

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-black/10 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 pt-16 pb-8">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-8 pb-14">
          <button data-testid="footer-logo" onClick={() => scrollTo("#top")} className="font-display font-black text-3xl tracking-tighter uppercase text-ink text-left">
            simply<span className="text-brand">Owner</span>
          </button>
          <div className="flex flex-wrap gap-3">
            <button
              data-testid="footer-cta-owner"
              onClick={() => scrollTo("#contact")}
              className="bg-brand hover:bg-black text-white font-display font-bold text-sm uppercase tracking-wide px-7 py-3 rounded-full transition-colors duration-300"
            >
              Become the owner
            </button>
            <button
              data-testid="footer-cta-how"
              onClick={() => scrollTo("/how-it-works")}
              className="bg-black/5 hover:bg-black/10 text-ink font-display font-bold text-sm uppercase tracking-wide px-7 py-3 rounded-full transition-colors duration-300"
            >
              See how it works
            </button>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-10 pb-14">
          {productCols.map((col) => (
            <div key={col.title}>
              <div className="font-mono text-[10px] tracking-[0.2em] uppercase text-black/40 mb-5">{col.title}</div>
              <div className="flex flex-col gap-3 items-start">
                {col.items.map((label) => (
                  <LinkBtn key={label} label={label} href={FOOTER_FEATURE_HREFS[label] || "/features"} testid={`footer-product-${label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`} />
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-10 pb-14 border-t border-black/5 pt-12">
          <div>
            <div className="font-mono text-[10px] tracking-[0.2em] uppercase text-black/40 mb-5">Resources</div>
            <div className="flex flex-col gap-3 items-start">
              {resources.map((label) => (
                <LinkBtn key={label} label={label} href={FOOTER_FEATURE_HREFS[label] || "/features"} testid={`footer-resource-${label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`} />
              ))}
            </div>
          </div>
          <div>
            <div className="font-mono text-[10px] tracking-[0.2em] uppercase text-black/40 mb-5">Company</div>
            <div className="flex flex-col gap-3 items-start">
              {company.map((l) => (
                <LinkBtn key={l.label} label={l.label} href={l.href} testid={`footer-company-${l.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`} />
              ))}
            </div>
          </div>
          <div>
            <div className="font-mono text-[10px] tracking-[0.2em] uppercase text-black/40 mb-5">Support</div>
            <div className="flex flex-col gap-3 items-start">
              {support.map((l) => (
                <LinkBtn key={l.label} label={l.label} href={l.href} testid={`footer-support-${l.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`} />
              ))}
            </div>
          </div>
          <div>
            <div className="font-mono text-[10px] tracking-[0.2em] uppercase text-black/40 mb-5">The Promise</div>
            <p className="text-[15px] text-black/60 font-light leading-relaxed">One-time price. Zero commission. Live in under 7 days. Own them like an owner.</p>
          </div>
        </div>
      </div>

      <div className="border-t border-black/5">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-6 flex flex-col lg:flex-row items-center justify-between gap-4">
          <span className="font-mono text-[10px] tracking-[0.15em] uppercase text-black/40">© 2026 simplyOwner.com | All rights reserved.</span>
          <div className="flex flex-wrap items-center justify-center gap-6">
            {legal.map((label) => (
              <button
                key={label}
                data-testid={`footer-legal-${label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                onClick={() => legalRoutes[label] && (window.location.href = legalRoutes[label])}
                className="font-mono text-[10px] tracking-[0.15em] uppercase text-black/40 hover:text-brand transition-colors duration-200"
              >
                {label}
              </button>
            ))}
            <a data-testid="footer-admin-link" href="/admin" className="font-mono text-[10px] tracking-[0.15em] uppercase text-black/40 hover:text-brand transition-colors duration-200">
              Admin
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
